export default "__VITE_ASSET__Cv4JTIyM__"